

const defaultState = {
	statisticsCharts: [
		{
			chartIndex: 1,
			selectedChartType: 'Stacked',
			selectedChartValue: 'RecordCount',
			showOnEquipmentScreen: true,
			selectedChartValueField: 'CycleStatus',
			stackedChartGroup1: 'CycleStatus',
			stackedChartGroup2: 'OperatorName',
			chartTitle: 'CyclGrpOpr'
		},
		{
			chartIndex: 2,
			selectedChartType: 'Column',
			selectedChartValue: 'RecordCount',
			showOnEquipmentScreen: true,
			selectedChartValueField: 'Operator',
			selectedChartGroup: 'OperatorName',
			chartTitle: 'CyclGrpOprator'
		},
		{
			chartIndex: 3,
			selectedChartType: 'Pie',
			selectedChartValue: 'RecordCount',
			showOnEquipmentScreen: true,
			selectedChartValueField: 'CycleType',
			selectedChartGroup: 'CycleName',
			chartTitle: 'CyclGrpCyTyp'
		},
		{
			chartIndex: 4,
			selectedChartType: 'Stacked',
			selectedChartValue: 'RecordCount',
			showOnEquipmentScreen: false,
			selectedChartValueField: 'EquipmentList',
			stackedChartGroup1: 'EquipmentName',
			stackedChartGroup2: 'CycleName',
			chartTitle: 'CyclGrpEqThCyTy'
		},
		{
			chartIndex: 5,
			selectedChartType: 'Pie',
			selectedChartValue: 'RecordCount',
			showOnEquipmentScreen: false,
			selectedChartValueField: 'EquipmentType',
			selectedChartGroup: 'EquipmentTypeName',
			chartTitle: 'CyclGrpEqTyp'
		},
		{
			chartIndex: 6,
			selectedChartType: 'Pie',
			selectedChartValue: 'RecordCount',
			showOnEquipmentScreen: true,
			selectedChartValueField: 'ReviewStatus',
			selectedChartGroup: 'CycleActionStatus',
			chartTitle: 'CyclReview'
		},
		{
			chartIndex: 7,
			selectedChartType: 'Stacked',
			selectedChartValue: 'RecordCount',
			showOnEquipmentScreen: true,
			selectedChartValueField: 'Day',
			stackedChartGroup1: 'Day',
			stackedChartGroup2: 'CycleStatus',
			chartTitle: 'CyclDay'
		}
	],
	activeTab: 'cycles'
};
const cycles = (state = defaultState, action) => {
	switch (action.type) {
		case 'SET_CYCLES_STATISTICS_CHARTS':
			return {
				...state,
				statisticsCharts: action.statisticsCharts
			};
		case 'SET_CYCLES_ACTIVE_TAB':
			return {
				...state,
				activeTab: action.activeTab
			};
		case 'RESET_CYCLES_STATISTICS_CHARTS':
			return {
				...state,
				statisticsCharts: defaultState.statisticsCharts
			};
		default:
			return state;
	}
};
export default cycles;
